import { render, staticRenderFns } from "./CompanyDataImportModal.yaml?vue&type=template&id=743a126d&component"
import script from "./CompanyDataImportModal.yaml?vue&type=script&lang=ts&component"
export * from "./CompanyDataImportModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports